import useComponentSize from "@rehooks/component-size"
import * as React from "react"
import styled from "styled-components"

const Header = styled.header`
  background-color: ${(props) => props.theme.color.white};
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 1232px;
  z-index: 2;
`

const Placeholder = styled.div<{ height: number }>`
  height: ${(props) => props.height}px;
`

interface Props {
  children: React.ReactNode
}
const StickyHeader = (props: Props) => {
  const ref = React.useRef<HTMLElement>(null)
  const { height } = useComponentSize(ref)

  return (
    <>
      <Header ref={ref}>{props.children}</Header>
      <Placeholder height={height} />
    </>
  )
}

export default StickyHeader
